import { ConfigFormData } from '@/models/onboarding';

export function validation(formData: ConfigFormData) {
  return !!formData.value || !!formData.customValue;
}
